export default __webpack_public_path__ + "static/media/photo--sm--14.39075e03.jpg";